<template>
    <v-container fluid class="pa-0 ma-0 align-start" style="height: calc(100% - 58px) !important;">
        <v-banner style="z-index: 9999 !important;" app sticky class="pa-0 ma-0" width="100%">
            <v-row no-gutters class="white" style="height: 55px !important;"> 
                <v-col cols="12" xs="12" class="">
                    <v-tabs class="border-bottom-grey"  v-model="tab" height="53">
                        <v-tabs-slider color="red" background-color="black"></v-tabs-slider>
                        <v-tab class="white" v-for="(item, index) in items" :key="index" @click="colsNo = 12;" :to="item.path">
                            <v-icon class="mr-2">{{ item.icon }}</v-icon> <span class="caption">{{ item.name }}</span>
                        </v-tab>
                        <v-spacer />
                        <v-btn v-if="$vuetify.breakpoint.mdAndUp && ['DA', 'SA', 'SM', 'CM', 'CA'].includes(GET_currentUser.userLevel)" depressed color="secondary" class="ma-2 mr-2" @click="showProjectUsers()"><v-icon>icons8-person</v-icon>Project Users</v-btn>
                        <v-btn v-if="$vuetify.breakpoint.mdAndUp" depressed color="secondary" class="ma-2 mr-4" @click="MIX_go('/projects')">{{ $t(`buttons.backToProjects`) }}<v-icon>icons8-arrow</v-icon></v-btn>
                    </v-tabs>
                </v-col>
                <v-col cols="6" xs="6">
                </v-col>
            </v-row>
        </v-banner>
        <router-view>
        </router-view>    
        <v-dialog
            v-model="userListDialog"
            hide-overlay
            max-width="800"
            style="height: 60px !important; max-height: 60px !important; min-height: 60px !important; overflow-y: auto !important"
            >
            <v-card>
                <v-toolbar dark class="elevation-0" color="primary">
                    <v-toolbar-title class="pl-2">
                        <v-icon>icons8-person</v-icon>
                        Project Users
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn icon dark @click="userListDialog = false">
                            <v-icon>icons8-multiply</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-card-text class="mx-0 pa-4">
                
                    <div class="font-weight-bold grey--text text--darken-1">Below is a list of all users that have Site Access related to this Project, along with their Role and Organisation:</div>

                    <!-- <v-divider class="my-4"></v-divider> -->
                    <v-row v-if="!loading">
                        <div style="max-height: 500px; overflow-y: auto !important; overflow-x: hidden !important; width: 100% !important">
                            <v-row class="ml-2">
                                <v-col cols="12" sm="6" md="4" class="pa-1" v-for="(user, index) in projectUsers" :key="index">
                                    <!-- {{ user }} -->
                                    <v-row class="mx-2 d-flex align-center grey lighten-4" style="border-radius: 5px !important; height: 100% !important">
                                        <v-col cols="3" class="pa-0 ma-0 pl-3 flex justify-center align-center">
                                            <v-avatar size="40">
                                                <v-img v-if="user.profilePicFileURL !== null " @click="callUser" :src="user.profilePicFileURL" alt="user" class="frcuc-profileImage" :class="user.swappStatus === 0 " cover height="50" width="50"/>
                                                <v-icon v-else class="icons8-person" color="lightgrey" size="50"/>
                                            </v-avatar>
                                        </v-col>
                                        <v-col cols="9">
                                            <div class="caption font-weight-bold">{{ user.userName }}</div>
                                            <div class="caption">{{ user.userJobTitle }}</div>
                                            <div class="caption">{{ user.organisation.organisationName }}</div>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </div>
                    </v-row>
                    <v-row v-else>
                        <v-col cols="12" class="text-center">
                            <v-progress-circular
                                indeterminate
                                color="primary"
                            ></v-progress-circular>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import documentsList from "@/dummy-data/documents-list.json";
import projectHelpList from "@/dummy-data/project-help.json";
import projectList from "@/dummy-data/projects-list.json";

export default {
    name: "ProjectPage",
    components: {},
    data() {
        return {
            //breadcrumbs
            currentProject: [],
            breadcrumbs: [
                {
                    text: "Projects",
                    disabled: false,
                    href: "/projects",
                },
                {
                    text: "Project 2 - Electrical WP",
                    disabled: true,
                    href: "/projects/356gfuuf",
                },
            ],
            //tabs
            tab: null,
            
            text: "",

            //table
            projectHelp: projectHelpList,

            //users
            userListDialog: false,
            projectUsers: [],
            loading: false,
        };
    },
    computed: {
        ...mapGetters(['GET_panelLayout']),
        items(){
            return  [
                {
                    name: this.$t('project.projectPage.documents.tabName'),
                    icon: "icons8-documents",
                    path: `/projects/${this.$route.params.id}/documents`,
                },
                {
                    name: this.$t('access.title'),
                    icon: "icons8-warranty",
                    path: `/projects/${this.$route.params.id}/access`,
                },
                // {
                //   name: this.$t('project.projectPage.permits.tabName'),
                //   icon: "icons8-licence",
                //   path: `/projects/${this.$route.params.id}/permits`,
                // },
                // {
                //   name: this.$t('project.projectPage.team.tabName'),
                //   icon: "icons8-management",
                //   path: `/projects/${this.$route.params.id}/team`,
                // },
                // {
                //   name: this.$t('documentsTabs.actions'),
                //   icon: "icons8-checked-checkbox",
                //   path: `/projects/${this.$route.params.id}/actions`,
                // },
                // {
                //   name: this.$t('documentsTabs.monitoring'),
                //   icon: "icons8-eye",
                //   path: `/projects/${this.$route.params.id}/monitoring`,
                // }
            ]
        }
    },
    methods: {
        showProjectUsers() {
            this.loading = true
            this.getProjectAccess();
            this.userListDialog = true;
        },
        async getProjectAccess() {
            var t = this;
            var id = this.$route.params.id

            // get all site access passes for the project

            var customWhere = []
            customWhere.push ({ key: 'project.projectId', operator: '==', value: id });

            var collection = t.$firebase.db.collection('access')
            if (JSON.stringify(customWhere) !== '[]') {
                for (var i = 0; i < customWhere.length; i++) {
                    var query = { field: customWhere[i].key, operator: customWhere[i].operator, value: customWhere[i].value }
                    collection = collection.where(query.field, query.operator, query.value)   
                    console.log('query = ' + JSON.stringify(query, null, 2))
                }
            }
            var accessData = [];
            var users = [];
            collection.onSnapshot(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    var document = doc.data()
                    document.id = doc.id;
                    if (!document.hasOwnProperty('delete')) {
                        accessData.push(document);
                    } else if (t.showDeleted) {
                        accessData.push(document);
                    } else {
                        // Do not Show Concern
                    }
                });
                // go through all the access passes and get the user details
                for (var i = 0; i < accessData.length; i++) {
                    var accessitem = accessData[i];
                    if (accessitem.users && accessitem.users.length > 0) {
                        for (var j = 0; j < accessitem.users.length; j++) {
                            var user = accessitem.users[j];
                            if (users.indexOf(user) === -1) {
                                users.push(user);
                            }
                        }
                    }
                }
                console.log('users 1', JSON.stringify(users, null, 2))
                t.getProjectUsers(users)
            });

            // console.log('users 2', JSON.stringify(users, null, 2))

            // var usersResult = [];
            // for (var i = 0; i < users.length; i++) {
            //     var user = users[i];
            //     var userResult = await t.MIX_readDocumentById('users', user)
            //     usersResult.push(userResult);
            // }

            // console.log('accessData', JSON.stringify(accessData, null, 2))
            // console.log('users', JSON.stringify(usersResult, null, 2))


            // t.projectUsers = usersResult;

        },
        async getProjectUsers(users) {
            var t = this;
            var usersResult = [];
            for (var i = 0; i < users.length; i++) {
                var user = users[i];
                var userResult = await t.MIX_readDocumentById('users', user)
                usersResult.push(userResult.data);
            }
            // remove any duplicates in usersResult 
            usersResult = usersResult.filter((v,i,a)=>a.findIndex(t=>(t.id === v.id))===i)

            // order by userName 
            usersResult.sort((a, b) => (a.userName > b.userName) ? 1 : -1)
            t.projectUsers = usersResult;
            t.loading = false
        },
        closeItem() {
            //   this.colsNo = 12;
            //   this.showRightPanel = false;
            // for (var i = 0; i < this.headers.length; i++) {
            //   if (this.headers[i].hide === true) {
            //     this.headers[i].hidden = false;
            //   }
            // }
        },
    },
    mounted() {
        // console.log(this.$route.params.id);
        // var urlPath = window.location.pathname.split('/')
        // console.log(urlPath);
        // this.currentProject = urlPath[2];
        this.$store.commit("setPageRoute", projectList[0].name);
    // console.log(JSON.stringify(this.projectHelp, null, 2));
    },
};
</script>

